export const buttonStyles = {
  components: {
    Button: {
      variants: {
        "no-hover": {
          _hover: {
            boxShadow: "none",
          },
        },
        "transparent-with-icon": {
          bg: "transparent",
          fontWeight: "bold",
          borderRadius: "inherit",
          cursor: "pointer",
          _hover: {},
          _active: {
            bg: "transparent",
            transform: "none",
            borderColor: "transparent",
          },
          _focus: {
            boxShadow: "none",
          },
          _hover: {
            boxShadow: "none",
          },
        },
        // Nuevas variantes educativas
        "educational-primary": {
          bg: "primary.500",
          color: "white",
          fontWeight: "semibold",
          _hover: {
            bg: "primary.600",
            transform: "translateY(-2px)",
            boxShadow: "0 4px 12px rgba(24, 144, 255, 0.3)",
          },
          _active: {
            bg: "primary.700",
            transform: "translateY(0px)",
          },
        },
        "educational-secondary": {
          bg: "secondary.500", 
          color: "white",
          fontWeight: "semibold",
          _hover: {
            bg: "secondary.600",
            transform: "translateY(-2px)",
            boxShadow: "0 4px 12px rgba(82, 196, 26, 0.3)",
          },
          _active: {
            bg: "secondary.700",
            transform: "translateY(0px)",
          },
        },
        "educational-outline": {
          bg: "transparent",
          border: "2px solid",
          borderColor: "primary.500",
          color: "primary.500",
          fontWeight: "semibold",
          _hover: {
            bg: "primary.50",
            borderColor: "primary.600",
            color: "primary.600",
          },
          _active: {
            bg: "primary.100",
          },
        },
        "educational-ghost": {
          bg: "transparent",
          color: "primary.500",
          fontWeight: "medium",
          _hover: {
            bg: "primary.50",
            color: "primary.600",
          },
          _active: {
            bg: "primary.100",
          },
        },
      },
      baseStyle: {
        borderRadius: "12px",
        fontWeight: "medium",
        transition: "all 0.2s ease-in-out",
        _focus: {
          boxShadow: "0 0 0 3px rgba(24, 144, 255, 0.1)",
        },
        _disabled: {
          opacity: 0.4,
          cursor: "not-allowed",
          _hover: {
            transform: "none",
            boxShadow: "none",
          },
        },
      },
      sizes: {
        xs: {
          px: 3,
          py: 2,
          fontSize: "xs",
          h: 6,
        },
        sm: {
          px: 4,
          py: 2.5,
          fontSize: "sm", 
          h: 8,
        },
        md: {
          px: 6,
          py: 3,
          fontSize: "md",
          h: 10,
        },
        lg: {
          px: 8,
          py: 4,
          fontSize: "lg",
          h: 12,
        },
      },
    },
  },
};
